import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesAcceptCreditConditionsComponent} from "./sales-accept-credit-conditions.component";
import { SalesAcceptCreditConditionsGeneralComponent } from './general/sales-accept-credit-conditions-general.component';
import { SalesAcceptCreditConditionsTopUpLoanComponent } from './top-up-loan/sales-accept-credit-conditions-top-up-loan.component';
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {LibraryModule} from "library";
import {GeneralModule} from "../general/general.module";



@NgModule({
  declarations: [
    SalesAcceptCreditConditionsComponent,
    SalesAcceptCreditConditionsGeneralComponent,
    SalesAcceptCreditConditionsTopUpLoanComponent
  ],
  imports: [
    CommonModule,
    PrimengModule,
    LibraryModule,
    GeneralModule
  ],
  exports: [
    SalesAcceptCreditConditionsComponent,
    SalesAcceptCreditConditionsGeneralComponent,
    SalesAcceptCreditConditionsTopUpLoanComponent
  ]
})
export class SalesAceptCreditConditionsModule { }
